import moment from 'moment';
import { getEpochFromDateTime } from './sensorUtils';

const getDefaultWifiSchedule = () => ({
  wifi_schedule_date: moment().add(1, 'days').format('YYYY-MM-DD'),
  wifi_schedule_time: '00:00',
});

// A schedule that has already run is not shown; the form offers tomorrow 00:00 instead.
export const getWifiScheduleFromEpoch = (startTime) => {
  if (!startTime || startTime <= moment().unix()) return getDefaultWifiSchedule();
  const start = moment.unix(startTime);
  return {
    wifi_schedule_date: start.format('YYYY-MM-DD'),
    wifi_schedule_time: start.format('HH:mm'),
  };
};

// The baseline freezes what the form was filled with, so the clock moving on is not an edit.
export const getWifiScheduleState = (startTime) => {
  const schedule = getWifiScheduleFromEpoch(startTime);
  return { ...schedule, wifi_schedule_baseline: schedule };
};

export const isWifiScheduleInPast = (date, time) => (
  getEpochFromDateTime(date, time) <= moment().unix()
);

export const isWifiConfigChanged = (form, sensor) => {
  const { ssid, passphrase, wifi_schedule_date, wifi_schedule_time } = form;
  if (!ssid || !passphrase) return false;
  const saved = sensor || {};
  const baseline = form.wifi_schedule_baseline || {};
  return ssid !== saved.config_wifi_ssid ||
    passphrase !== saved.config_wifi_passphrase ||
    wifi_schedule_date !== baseline.wifi_schedule_date ||
    wifi_schedule_time !== baseline.wifi_schedule_time;
};
